import React, { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { LntButton, LntDrawer, LntSelect } from '@app/components/base'

import { postTranslationsConfigMonitoringTypes } from '@app/api/routes/translationsConfig'
import { getTypes } from '@app/api/routes/monitorings'

import { MONITORINGS_TYPES_KEY, TRANSLATIONS_CONFIG_KEY } from '@app/constants/queryKeys'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { SIZE } from '@app/constants'

import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { useNotification } from '@app/hooks'

import styles from './styles.module.scss'

import type { TranslationsAddMonitoringTypesDrawerProps } from './types'
import type { LntSelectProps } from '@app/components/base/Select/types'

const commonSelectProps: LntSelectProps = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle
}

export const TranslationsAddMonitoringTypesDrawer: React.FC<TranslationsAddMonitoringTypesDrawerProps> = props => {
  const { onClose } = props

  const [selectedIds, setSelectedIds] = useState<string[]>()

  const queryClient = useQueryClient()
  const notification = useNotification()

  const translationsConfigCompetitorsMutation = useMutation({
    mutationFn: postTranslationsConfigMonitoringTypes,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [TRANSLATIONS_CONFIG_KEY.monitoringTypes] })

      notification.success({
        message: 'Выбранные типы мониторинга добавлены для транслирования.'
      })

      onClose?.()
    }
  })

  const handleAddTranslationsConfigMonitoringTypes = async (): Promise<void> => {
    if (!selectedIds?.length) return

    translationsConfigCompetitorsMutation.mutate({ monitoringTypeIds: selectedIds })
  }

  const footerButtons: React.ReactNode = (
    <div className={ styles.translationsAddMonitoringTypesDrawer__footer }>
      <LntButton
        disabled={ !selectedIds?.length }
        onClick={ handleAddTranslationsConfigMonitoringTypes }
      >
        Добавить
      </LntButton>
    </div>
  )

  return (
    <LntDrawer
      { ...props }
      title='Добавление типа мониторинга'
      width={ 424 }
      footer={ footerButtons }
    >
      <LntSelect
        { ...commonSelectProps }
        placeholder={ FILTERS_PLACEHOLDERS.monitoringsTypeFilter }
        querySelect={ {
          queryKey: [MONITORINGS_TYPES_KEY.typesItems],
          queryFn: getTypes,
          select: getFilterFromEntities
        } }
        onChange={ value => setSelectedIds(value as string[]) }
      />
    </LntDrawer>
  )
}
